import { render, staticRenderFns } from "./NovelDetail.vue?vue&type=template&id=983fa4c2&scoped=true"
import script from "./NovelDetail.vue?vue&type=script&lang=ts"
export * from "./NovelDetail.vue?vue&type=script&lang=ts"
import style0 from "./NovelDetail.vue?vue&type=style&index=0&id=983fa4c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "983fa4c2",
  null
  
)

export default component.exports